export enum Status {
    REFRESHING = 'Refreshing',
    INITIALIZING = 'Initializing',
    CREATE_IN_PROGRESS = 'CreateInProgress',
    LICENSE_IN_PROGRESS = 'LicenseInProgress',
    SETUP_INITIALIZING = 'SetupInitializing',
    SETUP_IN_PROGRESS = 'SetupInProgress',
    CREATE_FAILED = 'CreateFailed',
    UPDATE_IN_PROGRESS = 'UpdateInProgress',
    UPDATE_FAILED = 'UpdateFailed',
    UPDATE_COMPLETED = 'UpdateCompleted',
    DELETE_IN_PROGRESS = 'DeleteInProgress',
    DELETE_FAILED = 'DeleteFailed',
    COMPLETE = 'Complete',
}
